import { createContext } from "react";
import type { User } from "oidc-client-ts";

export type AuthStatus = "loading" | "unconfigured" | "anonymous" | "authenticated" | "error";

export type AuthContextValue = {
  status: AuthStatus;
  user: User | null;
  error: string | null;
  isConfigured: boolean;
  isAuthenticated: boolean;
  isSigningOut: boolean;
  signIn: (returnTo?: string) => Promise<void>;
  completeSignIn: () => Promise<string>;
  signOut: () => Promise<void>;
  clearError: () => void;
};

export const AuthContext = createContext<AuthContextValue | null>(null);
